// extracted by mini-css-extract-plugin
export default {"Icon":"Sidebar_Icon__AfnA+"};